var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBackgroud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 76,
    viewBox: "0 0 70 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9997 68.64C53.9541 68.64 69.3197 53.2744 69.3197 34.32C69.3197 15.3656 53.9541 0 34.9997 0C16.0453 0 0.679688 15.3656 0.679688 34.32C0.679688 44.9926 5.55126 54.5274 13.192 60.822C13.2042 60.832 13.1934 60.8515 13.1784 60.8464C13.1693 60.8433 13.1597 60.8501 13.1597 60.8598V71.5042C13.1597 74.4834 16.2999 76.4171 18.9603 75.076L30.9717 69.0212C31.6351 68.6867 32.3783 68.5494 33.1202 68.5894C33.7425 68.623 34.3691 68.64 34.9997 68.64Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBackgroud);
export default __webpack_public_path__ + "static/media/check-backgroud.ce561c8a39850d58408b7b1151bf3552.svg";
export { ForwardRef as ReactComponent };